var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StandardSearchPageView',{ref:"table",attrs:{"colNum":3,"columns":_vm.columns,"queryParams":_vm.queryParams,"searchOptions":_vm.searchOptions,"requestPromise":_vm.loadDataList},scopedSlots:_vm._u([{key:"productInfoSlot",fn:function(ref){
var text = ref.text;
return [_c('ellipsis',{attrs:{"length":40,"tooltip":""}},[_vm._v(_vm._s(text))])]}},{key:"rateplanInfoSlot",fn:function(ref){
var text = ref.text;
return [_c('ellipsis',{attrs:{"length":60,"tooltip":""}},[_vm._v(_vm._s(text))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }